import React from "react";

import Body from "./Body";

const Article = {
  title: "Join the community",
  annotation: "Create and share your own projects",
  body: <Body />,
};

export default Article;
